<template lang="pug">
    .contentpage
        .section(v-if="filteredSections.length" v-for="(section, index) in filteredSections" :key="section.id" :class="section.key")
            Heading(v-if="section.key === 'heading'" :section="section")
            ImageSection(v-if="section.key === 'image'" :section="section")
            Description(v-if="section.key === 'description'" :section="section")
            PhotoAlbum(v-if="section.key === 'photoalbum'" :section="section")
            // Slider(v-if="section.key === 'slider'" :section="section")
            // CategoryPosts(v-if="section.key === 'categoryposts'" :max="4" :category="section.category")
            // Banners(v-if="section.key === 'banners'" :banners="section.contents")
            // SocialWall(v-if="section.key === 'socialwall'")
</template>

<script>

// import _ from 'lodash'
import { mapGetters } from 'vuex'

import Heading from '@/components/Heading'
import ImageSection from '@/components/ImageSection'
import Description from '@/components/Description'
import PhotoAlbum from '@/components/PhotoAlbum'
// import Slider from '@/components/Slider'
// import CategoryPosts from '@/components/CategoryPosts'
// import SocialWall from '@/components/SocialWall'
// import Banners from '@/components/Banners'

export default {
    name: 'BlogPage',
    components: {
        Heading,
        ImageSection,
        Description,
        PhotoAlbum,
        // Slider,
        // CategoryPosts,
        // SocialWall,
        // Banners,
    },
    computed: {
        filteredSections() {
            return this.sections.filter(section => {
                return section.key === 'heading'
                    || section.key === 'image'
                    || section.key === 'description'
                    || section.key === 'slider'
                    || section.key === 'photoalbum'
            })
        },
        ...mapGetters({
            sections: 'currentPage/sections',
        })
    }
}

</script>

<style lang="sass" scoped></style>
